import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ContactusLayer from "../../components/Contactus/ContactusLayer";


const Contactus = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Contact Us" />

        {/* UsersListLayer */}
        <ContactusLayer />

      </MasterLayout>

    </>
  );
};

export default Contactus;
